seedWebApp.controller('DicModalCtrl', ['$scope', '$uibModalInstance', 'DicService', 'TranslationService', 'dicID', 'ToastService',
    function DicModalCtrl($scope, $uibModalInstance, DicService, TranslationService, dicID, ToastService) {

        // constants
        var numStorages = 2;
        var numMaterialAlts = 3;

        $scope.item = {};
        $scope.translation = TranslationService.getActiveTranslation();
        $scope.dicID = dicID;
        $scope.materialAlts = [];

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.getDic = function () {
            $scope.loading = true;
            DicService.getDic($scope.dicID).then(function (response) {
                $scope.loading = false;
                var item = response.data;
                //if (item.AltMaterial01) {
                //    item.AltMaterial01.Sequence = 1;
                //}
                //if (item.AltMaterial02) {
                //    item.AltMaterial02.Sequence = 2;
                //}
                //if (item.AltMaterial03) {
                //    item.AltMaterial03.Sequence = 3;
                //}
                $scope.item = item;

                $scope.info = {
                    CreateUserID: $scope.item.CreateUserID,
                    CreateDate: $scope.item.CreateDate,
                    UpdateUserID: $scope.item.UpdateUserID,
                    UpdateDate: $scope.item.UpdateDate
                };

                //$scope.fillStorages($scope.item);
                //$scope.fillMaterialAlts($scope.item);

            }, function () {
                $scope.loading = false;
            })
        };


        console.log('getDick ' + $scope.dicID);


        if ($scope.dicID) {
            $scope.getDic();
        } else {
            //$scope.item.Storages = [];
            //$scope.fillStorages($scope.item);
            //$scope.fillMaterialAlts($scope.item);
        }

        $scope.doRefresh = function (item) {
            DicService.resetCache();
            $scope.getMaterial();
        };

        $scope.qtStockClass = function (item) {
            //console.log('qtStockClass ' + item);
            if (item) {
                if (item < 0) {
                    return 'qt-stocks-negative';
                }
                else {
                    return 'qt-stocks-positive';
                }
            }
            else {
                return 'qt-stocks'
            }
        };

        $scope.ok = function () {

            $scope.loading = true;
            var toastID = ToastService.createToast('Salvando material...', '', 0, 'wait');

            for (var i = 0; i < $scope.item.Storages.length; i++) {
                $scope.item.Storages[i].MaterialID = $scope.item.MaterialID;
            }

            DicService.saveDic($scope.item).then(
                function (result) {

                    $scope.loading = false;

                    ToastService.updateToast(toastID, 'Material ' + result.data.MaterialID + ' foi salvo!', '', 4000, 'success');
                    $uibModalInstance.close(result.data);
                },
                function (error) {

                    $scope.loading = false;

                    console.log('saveMaterial error: ');
                    console.log(error.data);

                    var errorMsg = error.data.Message;
                    var errorExc = error.data.ExceptionMessage;
                    ToastService.updateToast(toastID, 'Erro so salvar!' + errorMsg + ' ' + errorExc, '', 4000, 'error');
                }
            );
        };

        $scope.dicTypes = [
            { Key: 'Internal', Value: 'Internal' },
            { Key: 'Primary', Value: 'Primary' },
            { Key: 'Secondary', Value: 'Secondary' },
            { Key: 'System', Value: 'System' },            
            { Key: 'External', Value: 'External' },            

        ];

        //$scope.materialStorages = [];
        //MaterialService.getStorages().then(function (result) {
        //    $scope.materialStorages = [];
        //    result.data.map(function (e) {
        //        $scope.materialStorages.push({ Key: e.StorageID, Value: e.StorageID + ' - ' + e.StorageName });
        //    });
        //});

        //$scope.materialSearch = function (query) {
        //    return MaterialService.getMaterialsQuery(query)
        //        .then(function (response) {
        //            return response.data.map(function (item) {
        //                return item;
        //            });
        //        })
        //        .catch(function (err) {
        //            console.error(err);
        //        });
        //};

        //$scope.materialSelected = function (item) {
        //    $scope.item.MaterialAlts[item.indexAlt].AltMaterialID = item.MaterialID;
        //};
    }]
);

